import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const CustomPagination = ({ currentPage, totalPages, handlePageClick }) => {
  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 7) {
      // Show all pages if total is small
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 4) {
        // Show first few pages and last two
        pages.push(1, 2, 3, 4, 5, "...", totalPages - 1, totalPages);
      } else if (currentPage >= totalPages - 3) {
        // Show first two and last few pages
        pages.push(1, 2, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        // Middle range
        pages.push(
          1,
          2,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages - 1,
          totalPages
        );
      }
    }

    return pages;
  };

  const pages = getPageNumbers();

  return (
    <Pagination className="mt-3 justify-content-center">
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink previous onClick={() => handlePageClick(currentPage - 1)} />
      </PaginationItem>

      {pages.map((page, index) =>
        page === "..." ? (
          <PaginationItem key={index} disabled>
            <PaginationLink>...</PaginationLink>
          </PaginationItem>
        ) : (
          <PaginationItem key={index} active={page === currentPage}>
            <PaginationLink onClick={() => handlePageClick(page)}>
              {page}
            </PaginationLink>
          </PaginationItem>
        )
      )}

      <PaginationItem disabled={currentPage === totalPages}>
        <PaginationLink next onClick={() => handlePageClick(currentPage + 1)} />
      </PaginationItem>
    </Pagination>
  );
};

export default CustomPagination;
